import { hideElement, showElement, queryAll, setExpanded, setAriaLabel, getScreenOverlay } from "./dom.js";

export function initProductList() {
    const pl = document.querySelector(".product-list");
    if (!pl) return;

    const ov = getScreenOverlay();

    // Event delegation on body — survives swaps
    document.body.addEventListener("click", function(e) {
        const action = e.target.closest("[data-action]")?.dataset.action;
        if (!action) return;

        const filtersPanel = document.querySelector(".filter-panel");
        const sortPanel = document.querySelector(".sort-panel");

        switch(action) {
            case "open-filters":
                showElement(filtersPanel);
                showElement(ov);
                // Must run after showElement — writing scrollTop while the
                // panel is still display:none (no scrollable box yet) is a
                // no-op, so the old offset would otherwise survive reopen.
                filtersPanel.scrollTop = 0;
                break;
            case "close-filters":
                hideElement(filtersPanel);
                hideElement(ov);
                break;
            case "open-sort":
                showElement(sortPanel);
                showElement(ov);
                break;
            case "close-sort":
                hideElement(sortPanel);
                hideElement(ov);
                break;
        }
    });

    document.body.addEventListener("htmx:afterSwap", function(evt) {

        // Keep filter panel open after swap
        const filtersPanel = document.querySelector(".filter-panel");
        const ov = getScreenOverlay();
        showElement(filtersPanel);
        showElement(ov);
    });

    // Overlay click closes everything
    ov.addEventListener("click", () => {
        hideElement(document.querySelector(".filter-panel"));
        hideElement(document.querySelector(".sort-panel"));
        hideElement(ov);
    });
}